<template>
  <MouseOverTeaser
    v-if="teaser?.offer?.product"
    class="sustainable-teaser"
    :class="variant && `sustainable-teaser--${variant}`"
    :card="{
      tag: 'nuxt-link',
      href: `/geraete/${teaser.offer.product.slug}`,
    }"
  >
    <template #image>
      <CdnImage
        v-if="teaser.image?.src"
        class="sustainable-teaser__product"
        v-bind="teaser.image"
        lazy
      />
      <GoliathImageElement
        v-else
        :offer="teaser.offer"
        class="sustainable-teaser__product"
        v-bind="teaser.goliathImageProps"
        lazy
      />
    </template>

    <template #mouseOver="{ mouseOver }">
      <slot
        name="mouseOver"
        :mouse-over="mouseOver"
      />
    </template>

    <slot />
  </MouseOverTeaser>
</template>

<script setup lang="ts">
import MouseOverTeaser from '~/components/mouseover-teaser.vue';
import { GoliathImageElement } from '@i22team/td-longtail-vue-components';
import CdnImage from '~/components/cdn-image.vue';
import type { SustainableTeaserType } from './sustainable-teaser-types';

defineProps<{
  teaser: SustainableTeaserType | undefined;
  variant?: 'light' | 'dark';
}>();
</script>

<style scoped lang="scss">
.sustainable-teaser {
  height: 440px;
  --mouse-background: rgba(207, 216, 115, 0.5);
  --card-image-padding: 0;
  --card-container-content-flex: 0;
  --card-container-flex: 0;
  --card-container-padding: 0;
  cursor: pointer;

  &--light {
    --mouse-background: rgba(191, 203, 68, 0.5);
  }
  &--dark {
    --mouse-background: rgba(136, 145, 48, 0.5);
  }

  &__product {
    height: 100%;
  }
}
</style>
